var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.languages,"item-text":"name"},on:{"change":_vm.onChange},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('img',{attrs:{"src":_vm.getFlagURL(item.locale),"width":"18"}}),(!_vm.small)?_c('span',[_vm._v(" "+_vm._s(item.name))]):_vm._e()]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('img',{attrs:{"src":_vm.getFlagURL(item.locale),"width":"18"}}),_vm._v(" "+_vm._s(item.name)+"\n    ")]}}]),model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}})}
var staticRenderFns = []

export { render, staticRenderFns }